import { FaEye, FaFlag } from "react-icons/fa";
import Button from "../../components/Button/Button";
import StatusChip from "../../components/StatusChip/StatusChip";
import { LESSON_STATUS } from "./LessonPlannerConstant";
import { formatDate } from "./utils/lessonPlanUtils";

export const allLessonPlansTableConstants = (onView, serialStart) => [
  {
    title: "S.No",
    render: (lesson) => <span>{serialStart + lesson.rowIndex + 1}</span>,
  },
  {
    title: "Lesson title",
    render: (lesson) => (
      <span className="fw-semibold">
        {lesson.title}
        {lesson.isFlagged && <FaFlag className="text-danger ms-2" title={lesson.remark || "Flagged"} />}
      </span>
    ),
  },
  {
    title: "Teacher",
    render: (lesson) => <span>{lesson.teacherName || "—"}</span>,
  },
  {
    title: "Class",
    render: (lesson) => <span>{lesson.programName}</span>,
  },
  {
    title: "Subject",
    render: (lesson) => <span>{lesson.subjectName}</span>,
  },
  {
    title: "Unit / Chapter",
    render: (lesson) => <span>{lesson.unitChapter || "—"}</span>,
  },
  {
    title: "Lesson Date",
    render: (lesson) => <span>{formatDate(lesson.lessonDate) || "—"}</span>,
  },
  {
    title: "Status",
    render: (lesson) =>
      lesson.status === LESSON_STATUS.COMPLETED ? (
        <StatusChip tone="success">Completed</StatusChip>
      ) : (
        <StatusChip tone="warning">Pending</StatusChip>
      ),
  },
  {
    title: "Action",
    render: (lesson) => (
      <Button size="sm" variant="outline-primary" iconRight={<FaEye />} onClick={() => onView(lesson)}>
        View
      </Button>
    ),
  },
];
